'use client';

import { Box } from '@mui/material';
import { m } from '../framer-motion-rsc';

import { useResponsive } from '@larvitu/shared/react/hooks';

import { varContainer } from '..';

import type { BoxProps } from '@mui/material';
import type { MotionProps } from 'framer-motion';
import type { ReactNode } from 'react';

type IProps = BoxProps & MotionProps;

interface Props extends IProps {
  children: ReactNode;
  disableAnimatedMobile?: boolean;
}

export function MotionViewport({
  children,
  disableAnimatedMobile = true,
  ...other
}: Props) {
  const isDesktop = useResponsive( 'up', 'sm' );

  if (!isDesktop && disableAnimatedMobile) {
    return (
      <Box {...other}>
        {children}
      </Box>
    );
  }

  return (
    <Box
      component={m.div}
      initial="initial"
      whileInView="animate"
      viewport={{
        once: true,
        amount: 0.5,
      }}
      variants={varContainer()}
      {...other}
    >
      {children}
    </Box>
  );
}
